var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._b(
      { ref: "elem", staticClass: "vue3-circular-progressbar" },
      "div",
      _vm.wrapAttr,
      false
    ),
    [
      _c(
        "svg",
        _vm._b({}, "svg", _vm.svgAttr, false),
        [
          _vm.isGradient
            ? _c(
                "linearGradient",
                _vm._b({}, "linearGradient", _vm.gradientAttr, false),
                [
                  _c("stop", _vm._b({}, "stop", _vm.gradientStartAttr, false)),
                  _vm._v(" "),
                  _c("stop", _vm._b({}, "stop", _vm.gradientStopAttr, false))
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("circle", _vm._b({}, "circle", _vm.circleBgAttr, false)),
          _vm._v(" "),
          _c("circle", _vm._b({}, "circle", _vm.circleFgAttr, false)),
          _vm._v(" "),
          _vm.isShadow
            ? [
                _vm.shadow.inset === false
                  ? _c(
                      "filter",
                      _vm._b({}, "filter", _vm.shadowAttr, false),
                      [
                        _c(
                          "feDropShadow",
                          _vm._b({}, "feDropShadow", _vm.feShadowAttr, false)
                        )
                      ],
                      1
                    )
                  : _c(
                      "filter",
                      _vm._b({}, "filter", _vm.shadowAttr, false),
                      [
                        _c("feOffset", {
                          attrs: {
                            dx: _vm.feShadowAttr.dx,
                            dy: _vm.feShadowAttr.dy
                          }
                        }),
                        _vm._v(" "),
                        _c("feGaussianBlur", {
                          attrs: { stdDeviation: _vm.feShadowAttr.stdDeviation }
                        }),
                        _vm._v(" "),
                        _c("feComposite", {
                          attrs: {
                            operator: "out",
                            in: "SourceGraphic",
                            result: "inverse"
                          }
                        }),
                        _vm._v(" "),
                        _c("feFlood", {
                          attrs: {
                            "flood-color": _vm.feShadowAttr.floodColor,
                            "flood-opacity": _vm.feShadowAttr.floodOpacity,
                            result: "color"
                          }
                        }),
                        _vm._v(" "),
                        _c("feComposite", {
                          attrs: {
                            operator: "in",
                            in: "color",
                            in2: "inverse",
                            result: "shadow"
                          }
                        }),
                        _vm._v(" "),
                        _c("feComposite", {
                          attrs: {
                            operator: "over",
                            in: "shadow",
                            in2: "SourceGraphic"
                          }
                        })
                      ],
                      1
                    )
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.bgShadow
            ? [
                _vm.bgShadow.inset === false
                  ? _c(
                      "filter",
                      _vm._b({}, "filter", _vm.bgShadowAttr, false),
                      [
                        _c(
                          "feDropShadow",
                          _vm._b({}, "feDropShadow", _vm.feBgShadowAttr, false)
                        )
                      ],
                      1
                    )
                  : _c(
                      "filter",
                      _vm._b({}, "filter", _vm.bgShadowAttr, false),
                      [
                        _c("feOffset", {
                          attrs: {
                            dx: _vm.feBgShadowAttr.dx,
                            dy: _vm.feBgShadowAttr.dy
                          }
                        }),
                        _vm._v(" "),
                        _c("feGaussianBlur", {
                          attrs: {
                            stdDeviation: _vm.feBgShadowAttr.stdDeviation
                          }
                        }),
                        _vm._v(" "),
                        _c("feComposite", {
                          attrs: {
                            operator: "out",
                            in: "SourceGraphic",
                            result: "inverse"
                          }
                        }),
                        _vm._v(" "),
                        _c("feFlood", {
                          attrs: {
                            floodColor: _vm.feBgShadowAttr.floodColor,
                            floodOpacity: _vm.feBgShadowAttr.floodOpacity,
                            result: "color"
                          }
                        }),
                        _vm._v(" "),
                        _c("feComposite", {
                          attrs: {
                            operator: "in",
                            in: "color",
                            in2: "inverse",
                            result: "shadow"
                          }
                        }),
                        _vm._v(" "),
                        _c("feComposite", {
                          attrs: {
                            operator: "over",
                            in: "shadow",
                            in2: "SourceGraphic"
                          }
                        })
                      ],
                      1
                    )
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm.showPercent
        ? _c("span", { staticClass: "current-counter" }, [
            _vm._v(_vm._s(_vm.currentPercent) + " " + _vm._s(_vm.unit))
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d83dc3b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d83dc3b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom/CircleProgress.vue
// module id = null
// module chunks = 